import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=05e14c50&scoped=true&"
import script from "./dimension.vue?vue&type=script&lang=ts&"
export * from "./dimension.vue?vue&type=script&lang=ts&"
import style0 from "./dimension.vue?vue&type=style&index=0&id=05e14c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e14c50",
  null
  
)

export default component.exports